import { createDebugConfig, trackCustomEvent } from '@/configuration/setup/googleAnalytics';
import type { TabName, VatSubmissionAnalytics } from '@/features/administration/types';

export const FLOW_NAME = 'charging_contract_tab';

const debugConfig = createDebugConfig();

export const getTabName = (index: number): TabName => {
    const tabNames: Record<number, TabName> = {
        0: 'personal_info',
        1: 'contact_details',
        2: 'invoice_details',
        3: 'documents',
    };

    return tabNames[index] ?? 'unknown';
};

export const calculateTimeSpent = (startTime: number): number => Math.floor((Date.now() - startTime) / 1000);

export const trackTabActivity = (newTabIndex: number, currentTab: number): void => {
    trackCustomEvent(
        'tab_activity',
        {
            trigger: 'click',
            flow_name: FLOW_NAME,
            element_name: getTabName(newTabIndex),
            previous_tab: getTabName(currentTab),
            element_state: 'active',
        },
        debugConfig
    );
};

export const trackTabExit = (currentTab: number, startTime: number) => {
    trackCustomEvent(
        'tab_exit',
        {
            flow_name: FLOW_NAME,
            element_name: getTabName(currentTab),
            time_spent_seconds: calculateTimeSpent(startTime),
            element_state: 'inactive',
        },
        debugConfig
    );
};

export const trackVatSubmission = ({ totalVatNumbers, hasMultipleCountries }: VatSubmissionAnalytics) => {
    trackCustomEvent(
        'vat_submission',
        {
            trigger: 'submit',
            flow_name: FLOW_NAME,
            element_name: 'invoice_details',
            vat_count: totalVatNumbers,
            multiple_countries: hasMultipleCountries,
        },
        debugConfig
    );
};
